import React, { useContext, useState, useEffect, useCallback } from "react";
import api from "../../api";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import events from "../../context/events";
import TableList from "../../components/TableList";
import { ColumnsItem, JustifyContent } from "../../components/TableList/BaseComponents/Header";
import { getIconUrl, openLink, time } from "../../util";
import { changeEgovUrl } from "@/utils/tools";
import { Icons } from "../../Icon";
import Popover from "./Popover";
import openDeleteModal from "../../contextModal/DeleteModal";
import { pageSize } from "../../config/basics.config";
import { ActionFnEnum, ContextMenuMode, FileType, MenusType } from "../../types";
import { PageRouteName } from "../../batchOperate";
import UpdataService from "../../reloadUtils";
import { useNavigator } from "@/utils/NetworkCheck";
import { useListData } from "../../components/TableList/Use/useListData";
import JoyspaceController from "../../controllers/JoyspaceController";

const columns = [
  { title: "标题", key: "title", dataIndex: "title", ellipsis: true },
  {
    title: "收藏时间",
    key: "time",
    dataIndex: "time",
    width: "25%",
    // style: {
    //     minWidth: '142px',
    // },
    justifyContent: JustifyContent.Left
  },
  {
    title: "",
    key: "actions",
    dataIndex: "actions",
    actions: true,
    width: "5%",
    style: {
      minWidth: "30px"
    },
    // style: {
    //     minWidth: '20px',
    // },
    justifyContent: JustifyContent.Center
  }
];
const key = "COLLECTONS_PAGE";
// 获取数据
const getList = (params: any) => {
  return new Promise((resolve, reject) => {
    api.pages
      .collections(params)
      .then(async (res) => {
        if (res) {
          res.pages = (res.data || []).map((item: any) => {
            item.info.time = time.format(item.c_created_at);
            item.info.title = item.info.title || "无标题";
            // item.isDisabled = true;
            return item.info;
          });
          if (!useNavigator.onLine) {
            res.pages = await JoyspaceController?.setOffLineList(res.pages);
          }
          console.log(res.pages, "pages111122");
        }
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export default function () {
  const globalContext = useContext<GlobalContextConfig>(GlobalContext);
  const {
    list,
    setList,
    total,
    setTotal,
    loading,
    isLoadMore,
    setLoadMore,
    onButtom,
    setPageIndex
  } = useListData({
    requestPagesFunc: getList,
    isFilter: false,
    isCategory: false,
    key
  });

  const openPage = (columnsItem: ColumnsItem, item: any) => {
    if (!item.status && useNavigator.onLine) {
      openDeleteModal(FileType.Page, item.id);
      return;
    }
    if (columnsItem.key === "title") {
      openLink(item, globalContext.appRuntimeEnv.joyspaceHost);
    }
  };
  return (
    <div className="joyspace-list-table joyspace-child-list">
      <TableList
        isLoadMore={isLoadMore}
        columns={columns}
        diffHeight={50}
        list={list}
        loading={loading}
        pagination={true}
        isRoot={false}
        renderActions={(item: any, contextMenuMode = ContextMenuMode.Click) => {
          if (item.isDisabled) {
            return (
              <span className="joyspace-trigger-icon" style={{ color: "#cccccc" }}>
                {Icons.trigger}
              </span>
            );
          }
          return (
            <Popover
              contextMenuMode={contextMenuMode}
              pageId={item.id}
              type={item.page_type || item.type}
              fileType={FileType.Page}
              callbackProps={{
                data: item,
                setData: (data: any) => {
                  events.emit("list.partial.refresh", {
                    changeData: data,
                    key
                  });
                }
              }}
            />
          );
        }}
        preOptions={(item: any, data: any, isExist: any) => {
          return (
            item.dataIndex === "title" && (
              <img
                src={
                  !isExist ? changeEgovUrl(data.icon_url) : getIconUrl(data.type || data.page_type)
                }
                data-icon
              />
            )
          );
        }}
        onButtom={onButtom}
        handleItem={openPage}
        from={PageRouteName.COLLECTIONS_PAGE}
      />
    </div>
  );
}
